<mat-toolbar class="topbar">
  <!-- Mobile Menu -->
  <button mat-icon-button (click)="toggleMobileNav.emit()" *ngIf="!showToggle">
    <i-tabler name="menu-2" class="icon-20 d-flex" style="color: #693175;"></i-tabler>
  </button>
  <!-- --------------------------------------------------------------- -->

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button
  mat-icon-button

  aria-label="Notifications"
>
  <img
    src="/assets/images/profile/user-1.jpg"
    class="rounded-circle object-cover"
    width="35"
  />
  
</button> -->
<!-- <p style="color: white;padding-bottom: 0%;font-size:medium;margin-top: 20px;margin-left: 45px;">Member</p> -->
<!-- <p 
  style="color: black; padding-bottom: 0%; font-size: medium; margin-top: 20px; margin-left: 45px;"
  [ngClass]="{'hide-on-small-screen': isSmallScreen}">
  Member
</p> -->


<!-- <select class="form-control" (change)="onMemberClick($event)" [(ngModel)]="itemSelected" style="display:inline; width:auto; margin-left: 8px;background-color: #693175;color: #FFFFFF;text-align: left;">
  <option *ngFor="let member of members" [value]="member.c_CustomerId">{{member.c_CustomerName}}</option>
</select> -->


<!-- <select 
  class="form-control" 
  (change)="onMemberClick($event)" 
  [(ngModel)]="itemSelected" 
  style="display: inline; width: 125px; margin-left: 8px; background-color: white; color: black; text-align: left;border-color: #693175;"
  [ngClass]="{'small-screen-select': isSmallScreen}">
  <option *ngFor="let member of members" [value]="member.c_CustomerId">{{member.c_CustomerName}}  </option>
</select> -->

<!-- <div style="position: relative;">
  <select 
    class="form-control" 
    (change)="onMemberClick($event)" 
    [(ngModel)]="itemSelected" 
    style="display: inline; width: 175px; margin-left: 8px; background-color: white; color: black; text-align: left;"
    [ngClass]="{'small-screen-select': isSmallScreen}">
    <option *ngFor="let member of members" [value]="member.c_CustomerId" >{{member.c_CustomerName}}</option>
  </select>
  <div style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);">
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 3.5L5 7.5L9 3.5" stroke="#693175" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</div> -->
<div style="position: relative;" *ngIf="members && members.length > 0">
  <select 
    
    class="form-control" 
    (change)="onMemberClick($event)" 
    [(ngModel)]="itemSelected" 
    style="display: inline; width: 175px; margin-left: 8px; background-color: white; color: black; text-align: left;"
    [ngClass]="{'small-screen-select': isSmallScreen}">
    <option *ngFor="let member of members" [value]="member.c_CustomerId">{{member.c_CustomerName}}</option>
  </select>
  <div style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);">
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 3.5L5 7.5L9 3.5" stroke="#693175" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</div>



  <!-- <button mat-icon-button aria-label="Notifications">
    <i-tabler
      class="d-flex"
      name="bell"
      matBadge="1"
      matBadgeColor="primary"
      style="color: white;"
    ></i-tabler>
  </button> -->

  <span class="flex-1-auto"></span>
  <!-- <button mat-icon-button aria-label="Notifications" style="margin-right: 4%;background-color: #693175;"> -->
    <button mat-icon-button aria-label="Notifications" style="margin-right: 2%;background-color: #693175;height: 40px;width: 40px;padding: 8px; " >

    <i-tabler
      class="d-flex"
      name="bell"
      matBadgeColor="primary"
      style="color: white;"
      
    ></i-tabler>
  </button>
  <!-- <button mat-icon-button color="primary" aria-label="Example icon button with a home icon" style="background-color: #693175; padding: 6px;">
    <mat-icon style="color: white; font-size: 16px;">home</mat-icon>
</button> -->

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <a
    mat-flat-button
    color="primary"
    href="https://adminmart.com/"
    target="_blank"
    class="d-flex justify-content-center"
  >
    Download Free
  </a> -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="Notifications"
    style="background-color: #693175; height: 40px; width: 40px; padding: 8px;"
  >
  <i-tabler
      class="d-flex"
      name="user-circle"
      matBadgeColor="primary"
      style="color: white;"
    ></i-tabler>
    <!-- <img
      src="/assets/images/profile/user-1.jpg"
      class="rounded-circle object-cover"
      width="35"
    /> -->
  </button>
 
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <button mat-menu-item  [routerLink]="['/ui-components/userprofile']">
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="user" class="icon-18 d-flex"></i-tabler>
      </mat-icon>
      My Profile
    </button>
    
    <button mat-menu-item [routerLink]="['/ui-components/settings']">
      <mat-icon class="d-flex align-items-center"
        ><i-tabler name="settings" class="icon-18 d-flex"></i-tabler></mat-icon
      >Settings
    </button>
    <!-- <button mat-menu-item>
      <mat-icon class="d-flex align-items-center"
        ><i-tabler
          name="list-check"
          class="icon-18 d-flex"
        ></i-tabler></mat-icon
      >My Task
    </button> -->
   


    
    <div class="p-x-12 m-t-12">
      <a
      (click)="logout()"
        [routerLink]="['/authentication/login']"
        mat-stroked-button
        color="primary"
        class="w-100"
        >Logout</a
      >
    </div>
  </mat-menu>
  
</mat-toolbar>

<style>

@media screen and (max-width: 768px) {
  .small-screen-select {
    width: 150px; /* Adjust the width as per your requirement */
  }
}

@media screen and (max-width: 768px) {
  .hide-on-small-screen {
    display: none;
  }
}

</style>
